// extracted by mini-css-extract-plugin
module.exports = {"basePosition":"BasePosition_basePosition__1ohKb","position":"BasePosition_position__srhis","title":"BasePosition_title__2s6EC"};